import { useEffect } from 'react'

import { config } from '@/config'
import { useRouter } from '@/core'
import { useAnalytics } from '@/core/analytics'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ preSaleId: string }>()
  const { analytics } = useAnalytics()

  useEffect(() => {
    analytics?.track('preSaleLotteryCancel', {
      applicationKey: config.applicationKey,
      preSaleId: router.query.preSaleId,
    })
  }, [])

  return {
    state: {},
    actions: {},
  }
})
